(() => {
  if (window.saaBrandReady) return;
  window.saaBrandReady = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let motionFrame = 0;

  function updateAboutCardMotion() {
    motionFrame = 0;
    const viewportHeight = window.innerHeight || 1;
    document.querySelectorAll('.saa-about .about-card.about-motion-visible').forEach((card) => {
      const rect = card.getBoundingClientRect();
      const distanceFromCentre = (rect.top + (rect.height / 2) - (viewportHeight / 2)) / viewportHeight;
      const direction = card.closest('.card-right') ? -1 : 1;
      const drift = Math.max(-12, Math.min(12, distanceFromCentre * -14 * direction));
      card.style.setProperty('--about-card-drift', `${drift.toFixed(2)}px`);
    });
  }

  function requestAboutCardMotion() {
    if (motionFrame || reducedMotion.matches) return;
    motionFrame = window.requestAnimationFrame(updateAboutCardMotion);
  }

  function initReveal(root = document) {
    const elements = root.querySelectorAll('.saa [data-reveal]:not([data-reveal-ready])');
    if (!elements.length || reducedMotion.matches || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('revealed');
        entry.target.dataset.revealComplete = 'true';
        requestAboutCardMotion();
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

    elements.forEach((element, index) => {
      const order = Number(element.dataset.revealOrder ?? (index % 4));
      element.style.setProperty('--reveal-delay', `${Math.min(order, 3) * 120}ms`);
      element.dataset.revealReady = 'true';
      element.classList.add('reveal-ready');
      observer.observe(element);
    });
    requestAboutCardMotion();
  }

  function initAboutMotion(root = document) {
    const elements = root.querySelectorAll('.saa-about [data-about-motion]:not([data-about-motion-ready])');
    if (!elements.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.aboutMotionReady = 'true';
        element.classList.add('about-motion-ready', 'about-motion-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('about-motion-visible');
        requestAboutCardMotion();
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    elements.forEach((element) => {
      const delay = element.dataset.aboutMotion === 'media' ? 110 : 0;
      element.style.setProperty('--about-motion-delay', `${delay}ms`);
      element.dataset.aboutMotionReady = 'true';
      element.classList.add('about-motion-ready');
      observer.observe(element);
    });
  }

  function init(root = document) {
    initReveal(root);
    initAboutMotion(root);
  }

  function closeMobileMenu(event) {
    const link = event.target.closest('.mobile-nav a');
    if (!link) return;
    link.closest('.mobile-menu')?.removeAttribute('open');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('click', closeMobileMenu);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('scroll', requestAboutCardMotion, { passive: true });
  window.addEventListener('resize', requestAboutCardMotion);
})();

/* Saa Al Thahbi V44 consistency guard for Shopify-managed navigation/policy chrome. */
(() => {
  function cleanManagedText(root = document) {
    const isArabic = (document.documentElement.lang || '').toLowerCase().startsWith('ar');
    if (isArabic) {
      root.querySelectorAll('a, button, summary, span').forEach((el) => {
        if (el.children.length === 0 && el.textContent.trim() === 'التمور والهدايا') {
          el.textContent = 'منتجات صاع الذهبي';
        }
      });
    }
    if (location.pathname.includes('/policies/')) {
      const main = root.querySelector('#MainContent') || root;
      main.querySelectorAll('*').forEach((el) => {
        if (el.children.length === 0 && el.textContent.includes('Qatar, 0 Qatar')) {
          el.textContent = el.textContent.replaceAll('Qatar, 0 Qatar', 'Qatar');
        }
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => cleanManagedText());
  else cleanManagedText();
  document.addEventListener('shopify:section:load', (event) => cleanManagedText(event.target));
})();
